export default {
  title: "Add exhibition",
  eventNameInputPlaceholder: "Exhibition Name",
  subjectInputPlaceholder: "Subject",
  datepickerPlaceholder: "Dates"
};
